import angular from 'angular'

import railwayAsk from './services/ask.service'
import railwayData from './services/data.service'
import railwayFormat from './services/format.service'
import railwayGo from './services/go.service'
import railwayLocal from './services/local.service'
import railwayMetadata from './services/metadata.service'
import railwayRequest from './services/request.service'
import railwayResource from './services/resource.service'
import railway from './services/railway.service'

import myRailwayCreateForm from './directives/forms/myRailwayCreateForm'
import myRailwayEditForm from './directives/forms/myRailwayEditForm'
import myRailwayForm from './directives/forms/myRailwayForm'
import myRailwayModifPosition from './directives/edit/myRailwayModifPosition'
import myRailway from './directives/display/myRailway'
import myRailwayDisplay from './directives/display/myRailwayDisplay'
import mySelectRailway from './directives/inputs/mySelectRailway'
import myRailwaySelectCard from './directives/inputs/myRailwaySelectCard'

import railwayButtons from './resources/buttons.resource'
import railwayIcons from './resources/icons.resource'
import railwayFields from './resources/fields.resource'
import railwayLabels from './resources/labels.resource'

const name = 'railway'
angular.module(name, [])
  // ===== SERVICES ===== //
  .factory('railwayAsk', railwayAsk)
  .factory('railwayData', railwayData)
  .factory('railwayFormat', railwayFormat)
  .factory('railwayGo', railwayGo)
  .factory('railwayLocal', railwayLocal)
  .factory('railwayMetadata', railwayMetadata)
  .factory('railwayRequest', railwayRequest)
  .factory('railwayResource', railwayResource)
  .factory('$$railway', railway)
  // ===== DIRECTIVES ===== //
  .directive('myRailwayCreateForm', myRailwayCreateForm)
  .directive('myRailwayEditForm', myRailwayEditForm)
  .directive('myRailwayForm', myRailwayForm)
  .directive('myRailwayModifPosition', myRailwayModifPosition)
  .directive('myRailway', myRailway)
  .directive('myRailwayDisplay', myRailwayDisplay)
  .directive('mySelectRailway', mySelectRailway)
  .directive('myRailwaySelectCard', myRailwaySelectCard)
  // ===== RESOURCES ===== //
  .factory('railwayButtons', railwayButtons)
  .factory('railwayIcons', railwayIcons)
  .factory('railwayFields', railwayFields)
  .factory('railwayLabels', railwayLabels)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/railway/railway.module.js